
import { Component, Vue } from 'vue-property-decorator'
import CookiesDisclaimer from '~/components/common/CookiesDisclaimer.vue'
import MiniFooter from '~/components/common/footer/MiniFooter.vue'
import Header from '~/components/common/header/Header.vue'
import Subheader from '~/components/common/header/Subheader.vue'
import AutoApplicationModalProvider from '~/components/common/modals/auto-application-modal/AutoApplicationModalProvider.vue'

@Component({
  name: 'MailboxLayout',
  components: {
    CookiesDisclaimer,
    Subheader,
    Header,
    MiniFooter,
    AutoApplicationModalProvider
  }
})
export default class MailboxLayout extends Vue {
  created() {
    if (!this.$auth.loggedIn && !this.$config.useExternalLoginUi) {
      this.$modal.show(Vue.component('ModalAuthentication'), {
        success: () => this.$accessor.initStore(this.$config),
        close: () => (window.location.href = '/')
      })
    }
  }
}
